export default "\n{% block sw_skeleton_bar %}\n<div class=\"sw-skeleton-bar\">\n    <div class=\"sw-skeleton-bar__shimmer\"></div>\n</div>\n{% endblock %}\n";